import SessionEventProto from "../session-event-proto"

type Header = {
    taskId          : ID
    taskMessageId   : ID
    meetingId       : ID
    timeReportId    : ID
    isBulkUpdate    : boolean
}

export default class SessionTimeReportEvent extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)
        // a report belongs to a task OR to a meeting: the server sends both blocks,
        // with `id: null` in the one that does not apply (and may omit it entirely)
        this.header     = {
            taskId          : sessionEvent.task?.id,
            taskMessageId   : sessionEvent.taskMessage?.id,
            meetingId       : sessionEvent.meeting?.id,
            timeReportId    : sessionEvent.timeReport?.id,
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    process() {
        if (this.isDifferentCompany()) return false

        const id = '{0}-{1}'.f(this.header.taskId, this.header.taskMessageId)
        gd.modelBus.newUpdate('time-report', this.method, id, this.data, this.header)
    }
}
